import { useMutation } from '@tanstack/react-query';
import automateAxios from '../../../utils/automateAxios';
import { MutationKeys } from '../../mutation/mutation.enum';
import { AutomationMode, ProcessResponse } from '../../../models/Interface/Automation.interface';

interface ProcessFileParams {
  file: File;
  mode: AutomationMode;
  language: string;
  translationPrompt?: string;
}

const processFile = async (params: ProcessFileParams): Promise<ProcessResponse> => {
  const formData = new FormData();
  formData.append('file', params.file);
  formData.append('mode', params.mode);
  formData.append('language', params.language);
  if (params.translationPrompt) {
    formData.append('translation_prompt', params.translationPrompt);
  }

  const response = await automateAxios.post<ProcessResponse>('/process', formData);
  return response.data;
};

const useProcessFile = () => {
  return useMutation({
    mutationKey: [MutationKeys.PROCESS_AUTOMATION_FILE],
    mutationFn: processFile,
  });
};

export default useProcessFile;
